import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

interface ActivationLinkResponse {
  count: number;
  total_results: number;
  result: {
    id: number;
    email: string;
    first_name: string;
    last_name: 'string';
    roles: string[];
    is_active: boolean;
  };
}

export const useResendUserActivationLink = () => {
  const resendActivationLink = async ({
    customerId
  }: {
    customerId: number;
  }) => {
    const response = await Axios.post<ActivationLinkResponse>(
      POST_URL(customerId.toString()).resendUserActivationLink
    );
    return response.data;
  };

  return useMutation<
    ActivationLinkResponse,
    AxiosError<BaseError>,
    { customerId: number }
  >(resendActivationLink, {
    useErrorBoundary: false
  });
};
